import {
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemProps,
  Box,
  Typography,
} from '@mui/material';

type Props = ListItemProps & {
  primary: string;
  secondary?: string;
  primaryIcon?: React.ReactNode;
  secondaryIcon?: React.ReactNode;
};

export const StaticListItem = ({
  primary,
  secondary,
  primaryIcon,
  secondaryIcon,
  ...props
}: Props) => {
  return (
    <ListItem
      {...props}
      sx={(theme) => ({
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      })}
    >
      {primaryIcon && <ListItemIcon>{primaryIcon}</ListItemIcon>}

      <ListItemText
        primary={<Typography variant="body2">{primary}</Typography>}
      />

      <Box display="flex" alignItems="center">
        <Typography variant="body2" color="text.secondary">
          {secondary}
        </Typography>

        {secondaryIcon && <ListItemIcon>{secondaryIcon}</ListItemIcon>}
      </Box>
    </ListItem>
  );
};
